export const SEARCH_TOPICS = "TOPICS_LOADED";
export const LOAD_TOPICS_SUCCESS = "LOAD_TOPICS_SUCCESS";
export const RENDER_TOPIC_SUCCESS = "RENDER_TOPIC_SUCCESS";
